import { ProductStockStatus } from '../constants/product/product';
import type { VariationProductDetail } from '../model/product/detail';

/** Shares attribute matching and stock priority without choosing a platform-specific default. */
export const findMatchingProductVariation = <
  Variation extends Pick<VariationProductDetail, 'size' | 'pack' | 'status'>,
>(
  variations: readonly Variation[] | undefined,
  querySize?: string,
  queryPack?: string,
): Variation | undefined => {
  if (!querySize && !queryPack) {
    return undefined;
  }

  const matchingVariations =
    variations?.filter((variation) => {
      const isSizeMatch = !querySize || variation.size === querySize;
      const isPackMatch = !queryPack || variation.pack === queryPack;

      return isSizeMatch && isPackMatch;
    }) ?? [];

  return (
    matchingVariations.find((variation) => variation.status === ProductStockStatus.instock) ??
    matchingVariations.find((variation) => variation.status !== ProductStockStatus.outofstock) ??
    matchingVariations[0]
  );
};
